
import Car1 from '../assets/modelx.jpg'
import Car2 from '../assets/modelxx.jpg'
import Car3 from '../assets/modely.jpg'
import Car4 from '../assets/modelyy.jpg'
const Data = [
  {
    title: 'Model X',
    id:"1",
    price:"500",
    fButton: 'Prebook Now',
    sButton: 'More Details',
    car: Car3,
    head:'Gen X',
    textc:'black',
    details:'The Gen X cars are designed to perfectly fit in your smart world. Its energetic design and powerful BS VI compliant engine are always ready to fuel your fast-paced lifestyle. Its smart technology and safety features add fun and ease to every journey. Giving you the confidence to take on life and manoeuvre through twists and turns in the smart way!Seeing the world with different eyes is what drives us. And so we dedicate every waking moment to shaping the future.Each day, we bring the world another little step forward – with our ideas, our passion, and our visions for the future of mobility.'
  },
  {
    title: 'Model Y',
    id:"1",
    price:"500",
    fButton: 'Prebook Now',
    sButton: 'More Details',
    car: Car1,
    textc:'white',
    head:'Gen Y',
    details:'The Gen Y cars are designed to perfectly fit in your smart world. Its energetic design and powerful BS VI compliant engine are always ready to fuel your fast-paced lifestyle. Its smart technology and safety features add fun and ease to every journey. Giving you the confidence to take on life and manoeuvre through twists and turns in the smart way!Seeing the world with different eyes is what drives us. And so we dedicate every waking moment to shaping the future. Each day, we bring the world another little step forward – with our ideas, our passion, and our visions for the future of mobility.'

  },
  {
    title: 'Model Z',
    id:"1",
    price:"500",
    fButton: 'Prebook Now',
    sButton: 'More Details',
    car: Car2,
    head:'Gen Z',
    textc:'black',
    details:'The Gen Z cars are designed to perfectly fit in your smart world. Its energetic design and powerful BS VI compliant engine are always ready to fuel your fast-paced lifestyle. Its smart technology and safety features add fun and ease to every journey. Giving you the confidence to take on life and manoeuvre through twists and turns in the smart way! Seeing the world with different eyes is what drives us. And so we dedicate every waking moment to shaping the future. Each day, we bring the world another little step forward – with our ideas, our passion, and our visions for the future of mobility.'

  },
  {
    title: 'Model 1',
    id:"1",
    price:"500",
    fButton: 'Prebook Now',
    sButton: 'More Details',
    car: Car4,
    head:'Model 1',
    textc:'white',
    details:'The Model 1 cars are designed to perfectly fit in your smart world. Its energetic design and powerful BS VI compliant engine are always ready to fuel your fast-paced lifestyle. Its smart technology and safety features add fun and ease to every journey. Giving you the confidence to take on life and manoeuvre through twists and turns in the smart way! Seeing the world with different eyes is what drives us. And so we dedicate every waking moment to shaping the future. Each day, we bring the world another little step forward – with our ideas, our passion, and our visions for the future of mobility.'


  },
  /*   {
    title: 'Lowest Cost Solar Panels',
    fButton: 'Prebook Now',
    sButton: 'More Details',
    car: Car5,
  },
  {
    title: 'Solar for New Roofs',
    fButton: 'Prebook Now',
    sButton: 'More Details',
    car: Car6,
  },
  {
    title: 'Accessories',
    fButton: 'Prebook Now',
    sButton: 'More Details',
    car: Car7,
  }, */
]

export default Data